export const AUTH_TOKEN = '@recurrence-auth-token'
export const AUTH_TOKEN_CUSTOMER = '@recurrence-auth-token-customer'
export const SUBSCRIBE_CART = '@recurrence-subscribe-cart'
